import { getPriceValue, getNumericValueFromDistance } from "@/util/formatNumber"
import useSWR from "swr"
import Shipments from "@/sections/shipments"
import ShipmentService from "@/services/shipment"

const fetcher = async () => {
  const response = await ShipmentService.previousShipment()
  return response.data ? response.data.data : []
}
export interface PreviousShipmentProps {
  blok: {
    title?: string
    subtitle?: string
  }
}
const PreviousShipmentsBlock: React.FC<PreviousShipmentProps> = ({ blok }) => {
  const { title, subtitle = "" } = blok
  const { data, error } = useSWR("recent_shipments", fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    dedupingInterval: 8 * 60 * 1000,
  })

  const shipments = !!data?.length
    ? data?.map((shipment: Record<string, any>) => ({
        id: shipment.id,
        title: `Shipment from ${shipment.pickupCity}, ${shipment.pickupStateCode} to ${shipment.deliveryCity}, ${shipment.deliveryStateCode}`,
        winner: shipment.driverName,
        amount: getPriceValue(shipment.price),
        mil: getNumericValueFromDistance(shipment.distance),
      }))
    : []

  return (
    <Shipments
      shipments={error ? [] : shipments}
      subtitle={subtitle}
      title={title}
    />
  )
}

export default PreviousShipmentsBlock
